import { useEffect, useState } from 'react';
// import Container from 'react-bootstrap/Container';
// import { Link } from 'react-router-dom';
import { NavLink, useLocation } from 'react-router-dom';
import logo from '../Img/DELTRANS_Logo-removebg-preview.png';
// import logo1 from '../Img/Bharat-Rug Logo.jpg';
import './Navbar.css';
import {Nav, Navbar, NavDropdown, Offcanvas, Image } from 'react-bootstrap';

function BasicExample() {
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false); // <-- control navbar

  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = () => setExpanded(false); // close after click

   // check if current path is one of the Products children
  const isProductsPage = [
    "/Cargo",
    "/Vessel",
    "/Global",
    "/Logistics",
    "/Import",
    "/Customs",
    "/AirChartering",
    "/Bags",
    "/Holiday"
  ].some(path => location.pathname.startsWith(path));

  return (
    <Navbar
      collapseOnSelect
      expand="xl"
      expanded={expanded}               // controlled state
      onToggle={setExpanded}            // keep state in sync
      className={`custom-navbar ${scrolled ? 'scrolled' : ''}`}
      variant="light"
    >
      <Navbar.Brand
        as={NavLink}
        to="/"
        onClick={handleNavClick}
        className="mx-4 d-flex align-items-center gap-2 brand-title"
      >
        <Image src={logo} alt="logo" className="brand-logo m-0 p-0" />
        <h1 className="gradient-text m-0 p-0">DELTRANS GLOBAL FZE LLC</h1>
      </Navbar.Brand>

      <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expanded}`} />
      <Navbar.Offcanvas
        id={`offcanvasNavbar-expand-${expanded}`}
        aria-labelledby={`offcanvasNavbarLabel-expand-${expanded}`}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expanded}`}>
            <Navbar.Brand as={NavLink} to="/" onClick={handleNavClick}>
              <Image src={logo} alt="logo" height={60} />
            </Navbar.Brand>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="justify-content-end flex-grow-1 mx-4">
            <Nav.Link as={NavLink} to="/" className="px-4 fs-6" onClick={handleNavClick}>Home</Nav.Link>
            <Nav.Link as={NavLink} to="/About" className="px-4 fs-6" onClick={handleNavClick}>About</Nav.Link>

            <NavDropdown
              className={`px-4 fs-6 ${isProductsPage ? "active" : ""}`}
              title="Services"
              popperConfig={{ strategy: "fixed" }}>
              <NavDropdown.Item className='fs-6' as={NavLink} to="/Cargo" onClick={handleNavClick}>Project Bulk and
ODC Cargo Unit</NavDropdown.Item>
              <NavDropdown.Item className='fs-6' as={NavLink} to="/Vessel" onClick={handleNavClick}>Vessel Chartering</NavDropdown.Item>
              <NavDropdown.Item className='fs-6' as={NavLink} to="/Global" onClick={handleNavClick}>Global Freight Forwarding</NavDropdown.Item>
              <NavDropdown.Item className='fs-6' as={NavLink} to="/Logistics" onClick={handleNavClick}>Logistics and Warehousing</NavDropdown.Item>
              <NavDropdown.Item className='fs-6' as={NavLink} to="/Import" onClick={handleNavClick}>Import</NavDropdown.Item>
              <NavDropdown.Item className='fs-6' as={NavLink} to="/Customs" onClick={handleNavClick}>Customs ,Vat and
Duty Management</NavDropdown.Item>
              <NavDropdown.Item className='fs-6' as={NavLink} to="/AirChartering" onClick={handleNavClick}>Air Chartering and
Freight Management</NavDropdown.Item>
              {/* <NavDropdown.Item className='fs-6' as={NavLink} to="/Bags" onClick={handleNavClick}>Bags</NavDropdown.Item>
              <NavDropdown.Item className='fs-6' as={NavLink} to="/Holiday" onClick={handleNavClick}>Holiday</NavDropdown.Item> */}
            </NavDropdown>            

            {/* <Nav.Link as={NavLink} to="/Resources" className="px-4 fs-6" onClick={handleNavClick}>Resources</Nav.Link> */}
            <Nav.Link as={NavLink} to="/Industries" className="px-4 fs-6" onClick={handleNavClick}>Industries</Nav.Link>
            <Nav.Link as={NavLink} to="/Contact" className="px-4 fs-6" onClick={handleNavClick}>Contact</Nav.Link>
            
          </Nav>
        </Offcanvas.Body>
      </Navbar.Offcanvas>
    </Navbar>
  );
}

export default BasicExample;

